// extracted by mini-css-extract-plugin
export default {"dashboard-page":"style_dashboard-page__1AaB4"};